// Central design tokens for the V-Tech Industries UI.
// Keeping these in one place makes it easy to retheme without hunting through JSX.

export const color = {
  bg: '#07090e',
  bgAlt: '#0b0f17',
  panel: 'rgba(255,255,255,.025)',
  panelBorder: 'rgba(255,255,255,.08)',
  text: '#eef1f6',
  textMuted: '#a9b3c6',
  textDim: '#8a93a6',
  textFaint: '#7b8698',
  textFainter: '#525c6e',
  accent: '#4d8dff',
  accentSoft: '#7fb0ff',
  accentBg: 'rgba(77,141,255,.12)',
  accentBorder: 'rgba(77,141,255,.25)',
  danger: '#ff6b6e',
};

export const font = {
  display: "'Space Grotesk', sans-serif",
  body: "'IBM Plex Sans', system-ui, sans-serif",
  mono: "'JetBrains Mono', monospace",
};

export const maxWidth = 1280;
